import locale from '../../../utils/locale';

export default [
    {
        name: 'addressLine1',
        label: locale('addressLine1'),
        type: 'autoFillAddress',
        readable: true,
        editable: true,
        required: true
    },
    {
        name: 'addressLine2',
        label: locale('addressLine2'),
        type: 'text',
        readable: true,
        editable: true,
        required: true
    },
    {
        name: 'city',
        label: locale('city'),
        type: 'text',
        readable: true,
        editable: true,
        required: true
    },
    {
        name: 'state',
        label: locale('state'),
        type: 'text',
        readable: true,
        editable: true,
        required: true,
        maxLength: 2,
        regEx: /(^(([Aa][EeLlKkSsZzRr])|([Cc][AaOoTt])|([Dd][EeCc])|([Ff][MmLl])|([Gg][AaUu])|([Hh][Ii])|([Ii][DdLlNnAa])|([Kk][SsYy])|([Ll][Aa])|([Mm][EeHhDdAaIiNnSsOoTt])|([Nn][EeVvHhJjMmYyCcDd])|([Mm][Pp])|([Oo][HhKkRr])|([Pp][WwAaRr])|([Rr][Ii])|([Ss][CcDd])|([Tt][NnXx])|([Uu][Tt])|([Vv][TtIiAa])|([Ww][AaVvIiYy]))$)/
    },
    {
        name: 'zip',
        label: locale('zip'),
        type: 'text',
        readable: true,
        editable: true,
        required: true,
        maxLength: 5,
        regEx: /(^\d{5}$)|(^\d{5}-\d{4}$)/
    }
]


// WEBPACK FOOTER //
// ./src/containers/PickupForm/fieldStructure/pickupAddress.js